import { DocumentsContext, IDocuments } from 'Context/DocumentsContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { DOCUMENTS_REDUCER_CASE } from 'Enum/documents';
import { useDictionary, useIsDesktop } from 'Hooks';
import CustomNewAutoComplete from 'Modules/UniversalRequest/ParentCategoriesList/CustomNewAutoComplete';
import { useContext } from 'react';

export const Search = () => {
  const {
    documents,
    dispatchDocuments,
    filter,
    advancedFilterActivationHandler,
  } = useContext(DocumentsContext);

  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);

  const initOptions = (docs: IDocuments) => {
    if (isDesktop) {
      const thisYearDocArr = Object.entries(docs.results).map(
        ([period, docs]) => ({
          docs,
        })
      );

      thisYearDocArr.push({ docs: docs.previousYearsResults });

      const thisYearDocOptions = thisYearDocArr.flatMap((period) =>
        period.docs.flatMap((doc) => [doc.name, doc.subjectName])
      );
      return [...new Set(thisYearDocOptions)];
    } else {
      const options = docs.previousYearsResults
        .filter((doc) => doc.name && doc.subjectName)
        .flatMap((item) => [item.name, item.subjectName]);
      return [...new Set(options)];
    }
  };

  const options = initOptions(documents);

  return (
    <CustomNewAutoComplete
      label={dictionary.searchFilter}
      value={filter.searchByNameOrSubject}
      options={options.map((option) => ({
        label: option || '',
        value: option || '',
      }))}
      setValue={(value: string | null) => {
        const updatedFilter = { ...filter, searchByNameOrSubject: value || '' };
        advancedFilterActivationHandler(updatedFilter);
        dispatchDocuments({
          type: DOCUMENTS_REDUCER_CASE.FILTER,
          payload: {
            value: { filter: updatedFilter },
          },
        });
      }}
      recentOptions={[]}
    />
  );
};
